import { render, staticRenderFns } from "./kategori.vue?vue&type=template&id=b54ffc80"
import script from "./kategori.vue?vue&type=script&lang=js"
export * from "./kategori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports